<template>
  <div>
    <!-- {{filterPayload}} -->
    <!-- <pre>{{studentAttendanceList}}</pre> -->
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <!-- <h4 v-if="!$route.params.clientObject">All Students List</h4> -->
      </div>
      <vs-table class="cstm_vuexy_table" :data="studentAttendanceList">
        <div
          slot="header"
          class="flex items-center"
          v-if="$route && $route.params && $route.params.clientObject"
        >
          <!-- {{$route.params}} -->
          <img
            style="width: 40px; height: 40px"
            class="rounded-full shadow-md block"
            v-if="$route.params.clientObject.picture"
            :src="$route.params.clientObject.picture"
            alt="image"
          />
          <img
            style="width: 40px; height: 40px"
            class="rounded-full shadow-md block"
            v-else
            src="http://scoolio-backend-dev.track-progress.com/staticAsset/emoticons/user_image.png"
            alt="image"
          />
          <a style="font-weight: 600" class="ml-2">
            <!-- asdadasdasdad -->
            <span v-if="$route.params.clientObject.first_name">{{ $route.params.clientObject.first_name }} </span>
            <span v-if="$route.params.clientObject.middle_name">{{ $route.params.clientObject.middle_name }} </span>
            <span v-if="$route.params.clientObject.last_name">{{ $route.params.clientObject.last_name }}</span>
          </a>
        </div>
        <template slot="thead">
          <vs-th style="min-width: 130px"
          v-if="!$route.params.clientObject"
          > Student Name </vs-th>
          <vs-th style="min-width: 130px"> Course Name </vs-th>
          <vs-th style="min-width: 130px"> Teacher Name </vs-th>
          <vs-th style="min-width: 130px"> Date </vs-th>

          <vs-th style="width: 185px"> Attendance </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name"
                      v-if="!$route.params.clientObject"

            >
              <div class="flex items-center">
                <img
                  v-if="data[indextr].picture"
                  style="width: 40px"
                  :src="data[indextr].picture"
                  alt="image"
                />
                <img
                  v-else
                  src="http://scoolio-backend-dev.track-progress.com/staticAsset/emoticons/user_image.png"
                  alt="user-img"
                  width="40"
                  height="40"
                  class="rounded-full shadow-md cursor-pointer block"
                />
                <!-- <pre>{{ data[indextr] }}</pre> -->
                <a
                  class="ml-2 cursor-pointer"
                  style="font-weight: 600"
                  @click.stop="
                    $router.push({
                      name: 'singleStudentAttendance',
                      params: {
                        client_user_id: data[indextr].client_user_id,
                        clientObject: {
                          first_name: data[indextr].first_name,
                        middle_name: data[indextr].middle_name,
                       last_name:data[indextr].last_name,


                          picture: data[indextr].picture,
                        },
                      },
                    })
                  "
                  >{{
                    `${data[indextr].first_name} ${
                      data[indextr].middle_name || ""
                    } ${data[indextr].last_name} `
                  }}
                  </a
                >
              </div>
              <!-- {{}} -->
            </vs-td>

            <vs-td :data="data[indextr].course_name">
                            <!-- <pre>{{data[indextr]}}</pre> -->

              {{ data[indextr].course_name }}
            </vs-td>

            <vs-td :data="data[indextr].teacher_name">
              {{ data[indextr].teacher_name }}
            </vs-td>

                      <vs-td>
                        <!-- {{data[indextr]}} -->
                        <span
                        v-if="$route.params.clientObject"
                        >
                        {{data[indextr].schedule_date }}
                        </span>
                        <span
                        v-else
                        >
                        {{filterPayload.start_date}}
                         {{filterPayload.start_date | date_format_system_wise}}
                        </span>
                      </vs-td>


            <vs-td>
              <!-- <pre>{{data[indextr]}}</pre> -->
              <div @mouseleave="leavingMouse(data[indextr])">
                <!-- <a @mouseleave="leavingMouse()">Mouse Leave</a> -->
                <!-- {{data[indextr].attendance_marked}} -->
                <ul class="flex" v-if="!data[indextr].attendance_marked">
                  <li class="mr-2">
                    <vs-radio
                      v-model="data[indextr].attendance"
                      :vs-name="`attendance${indextr}`"
                      :vs-value="true"
                      @change="markingAttendance(true, data[indextr])"
                    >
                      Present</vs-radio
                    >
                    <vs-input
                      v-if="data[indextr].attendance"
                      style="width: 100px"
                      type="number"
                      placeholder="Delayed by"
                      min="1"
                      max="120"
                      v-model="data[indextr].delay_in_minutes"
                      @keyup.enter="
                        markingAttendance(
                          true,
                          data[indextr],
                          'delayed',
                          $event
                        )
                      "
                    />
                  </li>
                  <li class="mr-2">
                    <vs-radio
                      v-model="data[indextr].attendance"
                      :vs-name="`attendance${indextr}`"
                      :vs-value="false"
                      @change="markingAttendance(false, data[indextr])"
                      >Absent</vs-radio
                    >
                  </li>
                </ul>
                <div v-else class="flex items-center">
                  <span
                    class="attendance-badge"
                    :class="data[indextr].attendance ? 'present' : 'absent'"
                  >
                    {{ data[indextr].attendance ? "Present" : "Absent" }}
                  </span>
                  <!-- <a
                    class="material-icons edit_att"
                    @click="editAttendance(data[indextr])"
                    >edit</a
                  > -->
                </div>
                <!-- {{data[indextr].delay_in_minutes}} -->
                <small
                  v-if="
                    data[indextr].delay_in_minutes &&
                    data[indextr].attendance_marked &&
                    data[indextr].attendance
                  "
                  style="color: gray; font-weight: 600"
                  >Delayed by: {{ data[indextr].delay_in_minutes }} mins</small
                >
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
// import { attendanceMixin } from '../mixins/attendanceMixin'
import {
  fetchSingleAttendanceHistoryApi,
  setAttendanceApi
} from '@/api/attendance'

export default {
  // mixins: [attendanceMixin],
  props: {
    filterPayload: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      studentAttendanceList: []

    }
  },
  created () {
    console.log(this.filterPayload)
    // this.fetchEnrolled(this.filterPayload)
    this.fetchSingle()
  },
  methods: {
    leavingMouse (attendanceInfo) {
      // console.log(attendanceInfo)
      if (
        typeof attendanceInfo.attendance === 'boolean' &&
        !attendanceInfo.attendance_marked
      ) {
        // console.log('hi')
        attendanceInfo.attendance_marked = true
      }
      console.log(attendanceInfo)
    },
    presenCheck () {
      console.log('hi')
    },
    editAttendance (attendanceInfo) {
      console.log(attendanceInfo)
      attendanceInfo.attendance_marked = false
      /* indextr.attendance = ''
      indextr.delayed_num = null
      indextr.delayed_input = true */
    },
    delayedFunc (index) {
      console.log('hi enter')
      index.delayed_input = false
    },
    async fetchSingle () {
      try {
        console.log('Hi')
        this.$vs.loading({ text: 'Fetching Attendance List' })
        const payload = {
          // start_date: this.$moment(this.filterPayload.start_date).format(
          //   'YYYY-MM-DD'
          // ),
          // end_date: this.$moment(this.filterPayload.end_date).format(
          //   'YYYY-MM-DD'
          // ),
          course_id: this.filterPayload.course_id,
          client_user_id: this.filterPayload.client_user_id || null
        }
        const customer_id = localStorage.getItem('customer_id')
        const { data } = await fetchSingleAttendanceHistoryApi(
          customer_id,
          payload
        )
        console.log(data)
        this.mergeAttendace(data.data.students, data.data.attendance)

        // this.structuredStandardList(attendanceList)
        //
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    mergeAttendace (studentList, attendance) {

      const alreadyAttendanceGiven = attendance.map((ele) => {
        return {
          ...ele,
          attendance_id: ele.id,
          attendance_marked: true,
          schedule_date:this.$moment(ele.attendance_date).format('YYYY-MM-DD')
        }
      })

      let notGiven = []
      console.log(this.$route.params.clientObject)
      //checking for singleStudent And If Single Student Is there then need to do the client Side
     /*  if (!this.$route.params.clientObject) {
        notGiven = studentList.map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        })
      } else {
        console.log('Not Givent')
        notGiven = this.eachStudentNotMarkedData(studentList, attendance).map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        })
      } */
      console.log(this.filterPayload.attendance_type)
      if (this.filterPayload.attendance_type === 'Marked') {
        this.studentAttendanceList = [...alreadyAttendanceGiven]
      } else if (this.filterPayload.attendance_type === 'UnMarked') {
        this.studentAttendanceList = [...notGiven]

      } else {
        this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]

      }
      /* this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]
      console.log(this.studentAttendanceList) */
    },
    eachStudentNotMarkedData (studentList, attendanceList) {
      console.log(`hi${studentList}`)
      const student = []
      const attendanceGivenCombination = attendanceList.map(ele => {
        return `${ele.client_user_id}${ele.course_id}${this.$moment(ele.attendance_date).format('YYYY-MM-DD')}`
      })

      console.log(attendanceGivenCombination)

      console.log(attendanceGivenCombination)
      studentList.forEach(ele => {
        ele.schedule_date.forEach(eachScheduleDate => {
          console.log(eachScheduleDate)

          const stringChecking = `${ele.client_user_id}${ele.course_id}${this.$moment(eachScheduleDate).format('YYYY-MM-DD')}`

          console.log(stringChecking)


          console.log(this.$moment(eachScheduleDate).isBetween(this.filterPayload.start_date, this.filterPayload.end_date))
          if (this.$moment(this.$moment(eachScheduleDate).format('YYYY-MM-DD')).isBetween(
            this.$moment(this.filterPayload.start_date).format('YYYY-MM-DD'), this.$moment(this.filterPayload.end_date).format('YYYY-MM-DD'))) {
            if (!attendanceGivenCombination.includes(stringChecking)) {
              student.push({...ele, schedule_date:eachScheduleDate})

            }

          }
        })
        // true

      })
      // console.log(student)

      return student

    },
    async structuredStandardList (studentList) {
      return studentList.map((ele) => {
        return {
          attendance_id: null,
          id: ele.client_user_id,
          attendance: true,
          delay_in_minutes: 0,
          name: `${ele.first_name} ${ele.last_name}`,
          picture: `${ele.picture}`
        }
      })
    },
    markingAttendance (attendance, attendanceObject, type, event) {
      console.log(attendanceObject)
      console.log(event)
      const payload = {
        course_id: attendanceObject.course_id,
        attendance_date: this.$route.params.clientObject ? attendanceObject.schedule_date : this.filterPayload.start_date,
        client_user_id: attendanceObject.client_user_id,
        attendance: attendanceObject.attendance,
        delay_in_minutes: attendanceObject.delay_in_minutes
      }
      console.log(attendance)
      console.log(payload)


      if (type === 'delayed') {

        if (attendanceObject.delay_in_minutes > 1 && attendanceObject.delay_in_minutes <= 120) {
          if (
            event &&
        'keyCode' in event &&
        event.keyCode === 13 &&
        type === 'delayed'
          ) {
            attendanceObject.attendance_marked = true
          }
          this.submitAttendance(payload)

        } else {
          this.showSuccessMessage('Error', 'Attendance must be between 1 And 120', 'danger')
        }

      } else {
        this.submitAttendance(payload)

      }
    },
    async submitAttendance (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const data = await setAttendanceApi(customer_id, payload)
        console.log(data)
      } catch (error) {
        console.log(error)
      }
    }
  },
  directives: {},
  watch: {
    filterPayload: {
      deep: true,
      handler () {
        console.log(this.filterPayload)
        // this.fetchSingle()
        console.log(this.filterPayload)
        this.fetchSingle()
      }
    }
    /* 'studentAttendanceList' :  {
      deep:true,
      handler (value) {
        console.log(value)
      }

    } */
  }
}
</script>

<style lang="scss" scoped>
</style>
